<template>

    <div>
        <b-container>
            <div class="loaderBlock" v-if="loaded == false">
                <div class="loader"></div>
                <h2 class="loaderText">Loading...</h2>
            </div>
            <div v-if="loaded == true">
                <div class="HeaderSection">
                    <b-row class="marginBtnMob">
                        <!-- <b-col class="hideOnmob hidMobOn">
                        </b-col>
                        <b-col class="hideOnmob hidMobOn">
                        </b-col> -->
                        <b-col lg="5" sm="12">
                            <h2 class="FullScheduleTitle">
                            {{oomtitle}}
                            </h2>
                        </b-col>
                        <b-col class="hideOnmob">
                            <b-nav card-header pills>
                                <template v-if="this.name == ''">
                                    <b-dropdown :text="oomshortTitle">
                                        <b-dropdown-item
                                        v-on:click="getoomList"
                                        v-for="(info,
                                        index) in listData.slice().reverse()"
                                        :key="index"
                                        :title="info.code"
                                        :year="'2026'"
                                        :name="info.short_name"
                                        >{{ info.short_name }}</b-dropdown-item
                                        >
                                    </b-dropdown>
                                </template>
                                <template v-else>
                                    <b-dropdown :text="this.name">
                                        <b-dropdown-item
                                        v-on:click="getoomList"
                                        v-for="(info,
                                        index) in listData.slice().reverse()"
                                        :key="index"
                                        :title="info.code"
                                        :year="'2026'"
                                        :name="info.short_name"
                                        >{{ info.short_name }}</b-dropdown-item
                                        >
                                    </b-dropdown>
                                </template>
                            </b-nav>
                        </b-col>
                        <b-col class="hideOnmob">
                            <b-nav card-header pills>
                                <b-dropdown :text="this.id + ' Season'">
                                    <b-dropdown-item
                                    v-on:click="changeYear"
                                    v-for="(seasons,
                                    index) in tm_params.seasons.seasons_entry.slice().reverse()"
                                    :key="index"
                                    :title="seasons.code"
                                    :year="seasons.code"
                                    >{{ seasons.desc }}</b-dropdown-item
                                    >
                                </b-dropdown>
                            </b-nav>
                        </b-col>
                    </b-row>
                    <!-- <b-row>
                        <b-col>
                            <h2 class="FullScheduleTitle">
                            {{oomtitle}}
                            </h2>
                        </b-col>
                    </b-row> -->
                </div>
                <Oom
                    :config="config"
                    :tm_params="tm_params"
                    :data="data"
                    :id="id"
                />
            </div>
        </b-container>
    </div>
</template>
<script>
import { Oom } from "@ocs-software/vue-ocs";
// import axios from 'axios';
import apiCall from "@/services/api.js";
export default {
  name: "OOM",
  props:["config"],
  components: {
    Oom
  },
  data: function() {
    return {
        oomData: [],
        data: [],
        id: [],
        code:[],
        tm_params: [],
        reports: [],
        course: [],
        season: [],
        white: true,
        listData: [],
        name:[],
        oomcashType:'',
        loaded: false
        
    };
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    }
  },
  methods: {
    getoomList: function(event) {
      var id = event.target.getAttribute("year");
      var code = event.target.getAttribute("title");
      var name = event.target.getAttribute("name");
      return (
        (this.id = id),
        (this.code = code),
        (this.name = name),
        apiCall
          .oomswitch(id, code)
          .then(({ data }) => {
            this.data = data;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          })
      );
    },
    changeYear: function(event) {
      var id = event.target.getAttribute("title");
      return (
        (this.id = id),
        apiCall
          .oom(id)
          .then(({ data }) => {
            this.data = data;
            this.oomtitle = data.full_name;
            this.oomshortTitle = data.short_name;
            this.oomcashType = data.oom_type;
            console.log("this.oomcashType")
            console.log(this.oomcashType)
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          })
      );
    },
    isMobile() {
      if( screen.width <= 500 ) {
        return true;
      }
      else {
        return false;
      }
    },
  },
    async mounted() {
        try {
        // First call, await for call to return
        let first_call = await apiCall.tmParamsBase();
        console.log("first_call")
        console.log(first_call)
        this.tm_params = first_call.data;
        this.id = first_call.data.tm_params.season_code;
        console.log("this.id")
        console.log(this.id)
        this.loading = false;
        // Second call, await for call to return
        this.id = first_call.data.tm_params.season_code;
        let second_call = await apiCall.oom(this.id);
        this.data = second_call.data;
        this.oomtitle = second_call.data.full_name;
        this.oomshortTitle = second_call.data.short_name;
        this.oomcashType = second_call.data.oom_type;     
        console.log("this.oomcashType")
        console.log(this.oomcashType)
        this.loaded = true
        let third_call = await apiCall.tmStats(this.id);
        this.listData = third_call.data.ooms.ooms_entry;
        // this.data = third_call.data.ooms.ooms_entry;
        console.log( "this.listData")
        console.log( this.listData)
        this.loading = false;
        } catch (error) {
        console.log("error in await calls");
        console.log(error);
        throw error;
        }
    },
}
</script>
<style scoped>
::v-deep th.cell.fields:nth-child(2) {
    text-align: left;    
}
::v-deep td.cell.name.playerNameNon {
    text-align: left;
}
.loaderBlock {
    margin: auto;
    display: block;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
}
.loaderText {
    color: #EB0A1E;
    font-size: 2rem;
    font-weight: 700;
    padding-top: 20px;
}
.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #EB0A1E;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
    margin: auto;
    display: block;
    text-align: center;
}
/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
h2.FullScheduleTitle {
    font-size: 2rem;
    font-weight: 700;
}
::v-deep .overflowPage {
  overflow: auto!important
}
::v-deep .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #B91B29;
  border-color: #B91B29;
}
::v-deep .dropdown-menu {
  width: 300px;
}
.sponsoredImage {
  width: 50px;
  margin-left: 10px;
}
::v-deep ul.nav.nav-pills.card-header-pills {
    float: right;
    margin-right: 0px;
}
::v-deep .btn {
    background-color: #EB0A1E;
    border-color: rgb(255, 255, 255);
    font-size: 1rem;
    border-radius: 0px;
    width: 300px;
}
::v-deep .btn:hover {
    background-color: #B91B29;
    border-color: rgb(255, 255, 255);
    font-size: 1rem;
    border-radius: 0px;
    width: 300px;
}
::v-deep .dropdown-toggle::after {
    margin-left: 10px;
}
.HeaderSection {
    margin-top: 3em;
    margin-bottom: 2em;
}
.posCent {
    text-align: center;
}
.flag {
    width: 30px;
}
td {
    padding: 11px;
    vertical-align: middle;
    border-top: 0 solid #dee2e6;
    font-size: 10pt;
    border: 0px!important;
}
::v-deep tr:nth-child(odd) {
    background: rgba(0,0,0,.05);
}
::v-deep .table-bordered thead th, .table-bordered thead td {
    border-bottom-width: 0px;
}
::v-deep thead {
    /* background: pink; */
    /* color: #fff; */
    background-color: #3E3E3E;
    color: #fff!important;
    padding-bottom: 10px;
    font-size: 10pt;
    font-weight: 100!important;
}
th {
    font-weight: 400;
}
::v-deep .table-bordered th, .table-bordered td {
    border: 0px solid #dee2e6!important;
}
.table-bordered {
    border: 0px solid #dee2e6;
}


@media only screen and (max-width: 768px) {
    .marginBtnMob {
        margin-bottom: 30px;
    }
    ::v-deep .btn {
        background-color: #EB0A1E;
        border-color: rgb(255, 255, 255);
        font-size: 12px;
        border-radius: 0px;
        width: 200px;
    }
}
</style>